import {omit} from 'lodash';
import React, {FC} from 'react';

import {RendererOf} from '../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {DropdownSeparator} from '../../../../libs/shared/ui/src/components/dropdowns/dropdownSeparator';
import {SimpleDropdown} from '../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown/simpleDropdown';
import {PopoverTransferProps} from '../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {PermissionSimpleDropdownItem} from '../../common/dropdowns/permissionSimpleDropdownItem';
import {EditSidebarCopy} from './editor/copy/edit-sidebar-copy';
import {HideInSidebarCopy} from './editor/copy/hide-in-sidebar-copy';
import {WorkspaceTeammateItem, WorkspaceTeammateItemProps} from './workspaceTeammateItem';

/*
 * Props.
 */

export interface WorkspaceTeammateItemContainerComponentProps extends WorkspaceTeammateItemProps {
  onEditWorkspaces: () => void;
  onHideFromWorkspace: (arg: number) => void;
  canBeHidden: boolean;
  shouldHideMoreMenu: boolean;
}

/*
 * Component.
 */

export const WorkspaceTeammateItemContainerComponent: FC<WorkspaceTeammateItemContainerComponentProps> = (
  props,
) => {
  const componentProps = omit(props, [
    'onEditWorkspaces',
    'canBeHidden',
    'shouldHideMoreMenu',
    'onHideFromWorkspace',
  ]);
  const onHide: () => void = () => {
    props.onHideFromWorkspace(props.teammate.id);
  };

  const renderMoreMenu = createRenderMoreMenu(props, onHide);
  return <WorkspaceTeammateItem {...componentProps} renderMenu={renderMoreMenu} />;
};

/*
 * Helpers.
 */

function createRenderMoreMenu(
  props: WorkspaceTeammateItemContainerComponentProps,
  onHide: () => void,
): RendererOf<PopoverTransferProps> | undefined {
  const {shouldHideMoreMenu} = props;
  if (shouldHideMoreMenu) {
    return undefined;
  }

  return (popoverProps) => renderMoreDropdown(popoverProps, props, onHide);
}

function renderMoreDropdown(
  popoverProps: PopoverTransferProps,
  props: WorkspaceTeammateItemContainerComponentProps,
  onHide: () => void,
) {
  const {canBeHidden, onEditWorkspaces} = props;

  return (
    <SimpleDropdown {...popoverProps}>
      {canBeHidden && (
        <>
          <PermissionSimpleDropdownItem onSelect={onHide}>
            <HideInSidebarCopy />
          </PermissionSimpleDropdownItem>
          <DropdownSeparator />
        </>
      )}

      <PermissionSimpleDropdownItem onSelect={onEditWorkspaces}>
        <EditSidebarCopy />
      </PermissionSimpleDropdownItem>
    </SimpleDropdown>
  );
}
